import React from 'react';

import styled from 'styled-components';
import { darkTheme } from 'theme';

import Button from '@material-ui/core/Button';
import Container from 'components/Container';
import Grid from '@material-ui/core/Grid';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { SectionWrapper } from 'components/Section';
import { ResponsiveBackgroundImg } from 'components/ResponsiveImg';

const Wrapper = styled(SectionWrapper)`
  position: relative;
  z-index: 0;
  background: ${props => props.theme.palette.background.default};
  width: 100%;
  padding: 5vh 0;
`;

const OverlayContainer = styled(Container)`
  position: relative;
  z-index: 1;
`;

const CTAButton = styled(Button)`
  margin: 40px 5px 0 5px;
`;

const FooterBackgroundImg = styled(ResponsiveBackgroundImg)`
  opacity: 0.25;
`;

const SimpleFooterCTA = ({
  title,
  heading,
  subheading,
  description,
  link = { title: '', href: '' },
  secondary_link = { title: '', href: '' },
  image,
  background_image,
  theme,
  ...other
}) => (
  <MuiThemeProvider theme={theme || darkTheme}>
    <Wrapper theme={theme || darkTheme} data-swiftype-index="false" {...other}>
      <OverlayContainer>
        <Grid container justify="center">
          <Grid item xs={12} align="center">
            <Typography variant="h4" gutterBottom>
              {heading || title}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {description || subheading}
            </Typography>
            <CTAButton
              href={link.href}
              size="large"
              variant="contained"
              color="primary"
            >
              {link.title}
            </CTAButton>
            {secondary_link?.href && (
              <CTAButton
                href={secondary_link.href}
                size="large"
                variant="outlined"
                color="primary"
              >
                {secondary_link.title}
              </CTAButton>
            )}
          </Grid>
        </Grid>
      </OverlayContainer>
      {background_image && (
        <FooterBackgroundImg
          src={background_image.url}
          defaultWidth={1500}
          backgroundcolor="transparent"
        />
      )}
    </Wrapper>
  </MuiThemeProvider>
);

export default SimpleFooterCTA;
